import { axiosInstance } from "../../../../config/api/Axios";

export const getCostOfLivingApi = (currentCityId, comparisonCityId) =>
    axiosInstance.get(`/intelligence/cost-of-living/${currentCityId}/${comparisonCityId}`);
